import * as React           from 'react'
import { FormattedMessage } from 'react-intl'

import Button        from '@material-ui/core/Button'
import Card          from '@material-ui/core/Card'
import CardHeader    from '@material-ui/core/CardHeader'
import Dialog        from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle   from '@material-ui/core/DialogTitle'
import Divider       from '@material-ui/core/Divider'
import Table         from '@material-ui/core/Table'
import TableBody     from '@material-ui/core/TableBody'
import TableCell     from '@material-ui/core/TableCell'
import TableHead     from '@material-ui/core/TableHead'
import TableRow      from '@material-ui/core/TableRow'

import completionStateIconMap              from '../../project-utils/completion-state-icon-map'
import { TripartitaPackage }               from '../../redux'
import { pick }                            from '../../utils'
import withToggle, { InjectedToggleProps } from '../hocs/withToggle'
import withValue, { InjectedValueProps }   from '../hocs/withValue'
import LabelledData                        from './LabelledData'

interface TripartitaTableProps extends InjectedToggleProps, InjectedValueProps {
  tripartitaPackage: TripartitaPackage
}

const TripartitaTable: React.SFC<TripartitaTableProps> = ({
  tripartitaPackage:
    {
      initial,
      intermediate,
      final,
    },
  handleChange,
  value = {},
  activate,
  deactivate,
  isActive,
}) => {
  const phrasing = {
    status:       <FormattedMessage id={'dictionary.status'} />,
    tripartitas:  <FormattedMessage id={'project.tripartitas'} />,
    stage:        <FormattedMessage id={'dictionary.stage'} />,
    initial:      <FormattedMessage id={'dictionary.initial'} />,
    intermediate: <FormattedMessage id={'dictionary.intermediate'} />,
    final:        <FormattedMessage id={'dictionary.final'} />,
  }

  return (
    <>
      <Card>
        <CardHeader title={'Tripartitas'} />
        <Divider />
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                {phrasing.stage}
              </TableCell>
              <TableCell numeric>
                {phrasing.status}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {initial && (
              <TableRow
                hover={initial.done}
                className={initial.done ? 'cursor-pointer' : ''}
                onClick={() => {
                  if (!initial.done) return

                  handleChange(initial)
                  activate()
                }}
              >
                <TableCell>
                  {phrasing.initial}
                </TableCell>
                <TableCell numeric>
                  {completionStateIconMap[ initial.done ? 'done' : 'pending' ]}
                </TableCell>
              </TableRow>
            )}

            {intermediate && (
              <TableRow
                hover={intermediate.done}
                className={intermediate.done ? 'cursor-pointer' : ''}
                onClick={() => {
                  if (!intermediate.done) return

                  handleChange(intermediate)
                  activate()
                }}
              >
                <TableCell>
                  {phrasing.intermediate}
                </TableCell>
                <TableCell numeric>
                  {completionStateIconMap[ intermediate.done ? 'done' : 'pending' ]}
                </TableCell>
              </TableRow>
            )}

            {final && (
              <TableRow
                hover={final.done}
                className={final.done ? 'cursor-pointer' : ''}
                onClick={() => {
                  if (!final.done) return

                  handleChange(final)
                  activate()
                }}
              >
                <TableCell>
                  {phrasing.final}
                </TableCell>
                <TableCell numeric>
                  {completionStateIconMap[ final.done ? 'done' : 'pending' ]}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </Card>
      <Dialog open={isActive} fullWidth>
        <DialogTitle>
          <FormattedMessage id={'generic.tripartitaSummary'} />
        </DialogTitle>
        <DialogContent>
          <LabelledData
            data={pick(
              value,
              [
                'indicators',
                'challenge',
                'objectives',
                'superiorCommitment',
                'commitment',
              ]
            )}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={deactivate} color={'primary'}>
            <FormattedMessage id={'buttonActions.close'} />
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default withToggle(withValue(TripartitaTable))



// WEBPACK FOOTER //
// ./src/components/molecules/TripartitaTable.tsx